<div class="modal-header mb-10">
  <div class="modal-title">
    <h3 class="d-inline-block">Internal Test Results</h3>
    <button type="button" class="btn-close" (click)="dialogRef().close(false)">
      <span class="icon-close"></span>
    </button>
  </div>
</div>

<div class="modal-body">
  <app-phone-reports-test-result-table [reportId]="reportId()"></app-phone-reports-test-result-table>
</div>

<div class="modal-footer pt-15 mt-10 d-flex justify-content-end">
  <button class="btn btn-primary" type="submit" (click)="onCloseClick()">Close</button>
</div>
